<template>
    <div class="col1">
        <div class="header">
            <figure class="logo"><img src="@/assets/images/Simpas_Applied_Solutions.svg" alt="Simpas Applied Solutions"></figure>
            <h1>SIMPAS-applied<br>Solutions&trade;</h1>
            <h2>Farm Benefit Tool</h2>

            <div class="instructions">
                <p>See the value in prescriptively applying  multiple products in-furrow simultaneously with our helpful&nbsp;calculator.</p>
                <div class="calculator-guide">
                    <h3 class="accordion">Calculator Guide <img src="@/assets/images/icon_arrow.png" class="accordion accordion__arrow"/></h3>
                    <div class="panel">
                        <p><em>Note:</em> All gray fields are editable</p>
                        <ol>
                            <li>Choose <strong>one of the 2 crops</strong> from the drop-down menu in the Input&nbsp;section.</li>
                            <li>Fill in the <strong>number of acres&nbsp;grown</strong>.</li>
                            <li>Choose <strong>up to 3 treatment needs</strong>, select the <strong>desired product</strong>, then fill in the <strong>percentage of acres</strong> requiring&nbsp;treatment.</li>
                            <li>Fill in the <strong>current price of the crop&nbsp;selected</strong>.</li>
                            <li>The <strong>Results</strong> section will automatically calculate the <strong>Annual Net Value</strong> of <strong>Prescriptive Application</strong> versus <strong>Whole Field&nbsp;Application</strong>.</li>
                            <li>Finish by printing your results to <strong>review with your crop inputs&nbsp;retailer</strong>.</li>
                        </ol>
                        <p>You can also adjust the <strong>Average Yield Increase Per Acre</strong> number in the <strong class="blue">Results</strong> section to see the effect on&nbsp;value.</p>
                    </div>
                </div>

                <div id="simpas-link">
                    <p>For more information about SIMPAS-applied Solutions, visit&nbsp;<a href="https://www.simpas.com" target="_blank" rel="noopener noreferrer">SIMPAS.com</a>.</p>
                </div>
            </div>

            <p><router-link to="/forms" class="btn start-here">Start Here</router-link></p>
        </div>
    </div>

    <div class="col2">
        <div class="home-cols">
            <div class="home-col1">
                <Introduction />
            </div>
            <div class="home-col2">
                <figure class="photo">
                    <div class="circle"><img src="@/assets/images/pho_simpas.jpg" alt="Photo of tractor"></div>
                </figure>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import { defineAsyncComponent } from 'vue'

const Introduction = defineAsyncComponent(() =>
    import ('@/components/Introduction.vue'))

export default {
    name: 'Home',
    components: {
        Introduction
    },
    data() {
        return {
            show: true
        }
    }
}
</script>